<template>
  <a-result v-if="type==1" status="404" title="404" sub-title="Sorry, the page you visited does not exist.">
    <template #extra>
      <a-button type="primary" @click="toHome">
        Back Home
      </a-button>
    </template>
  </a-result>
  <a-result v-else status="warning" style="background:#fff;" :title="$t('common.renewAlert')" >
    <template #extra>
      {{$t('common.renewInfo')}} <a @click="toPersonalCenter">{{$t('common.memberCenter')}}</a> {{$t('actionTitles.renew')}}
    </template>
  </a-result>

</template>

<script>
import { isMobile } from "@/utils/tools.js";

export default {
  name: 'ExceptionHint',
  computed:{
    type:{
      get(){
        //type區分提示內容  1:404 頁面不存在，2：帳戶過期提示
        if (this.$route.params.type != undefined) {
          return parseInt(this.$route.params.type);
        }
        return 2;
      }
    }
  },
  created() {
    console.log("11");
    this.$store.dispatch("getUserInfo");//更新用戶的配置
  },
  methods: {
    toHome () {
      this.$router.push({ path: '/' })
    },
    toPersonalCenter() {
      if(this.$isMobile()) {
        this.$router.push({path: '/mobile'})
      } else {
        this.$router.push({path: '/member/account/basic'})
      }
    }
  }
}
</script>
